import styled from 'styled-components';
interface MoreButtonProps {
  showAll: boolean;
  setShowAll: (value: boolean) => void;
  name?: string;
  sectionId: string;
}
const MoreButton = ({
  showAll,
  setShowAll,
  name,
  sectionId,
}: MoreButtonProps) => {
  const handleScroll = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 120;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  return (
    <MoreButtonContainer
      onClick={() => {
        if (showAll) {
          handleScroll(sectionId);
        }
        setShowAll(!showAll);
      }}
    >
      <MoreButtonDivider />
      <Button>
        <div>
          {name} {showAll ? '접기' : '더보기'}
        </div>
        <img
          style={{
            transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
          src="/assets/images/arrow/Arrow_down.png"
          alt=""
        />
      </Button>
      <MoreButtonDivider />
    </MoreButtonContainer>
  );
};

export default MoreButton;

const Container = styled.div`
  width: 100%;
  color: black;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  line-height: 18.85px;
  word-wrap: break-word;
  border: 1px #e1e2e4 solid;
  border-radius: 4px;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const MoreButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  img {
    width: 16px;
    height: 16px;
  }
`;

const MoreButtonDivider = styled.div`
  flex: 1;
  height: 1px;
  background-color: #f7f7f9;
`;

const Button = styled.button`
  padding: 8px 20px;
  border-radius: 9999px;
  border: none;
  background-color: #f7f7f9;
  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: center;
  align-items: center;
  outline: none;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;

  &:active {
    background-color: #0000000a;
  }
`;
